import { Component } from '@angular/core';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-post-register-footer',
    templateUrl: './post-register-footer.component.html',
    styleUrls: ['./post-register-footer.component.css'],
    standalone: true,
    imports: [NgIf,TrackingDirective]
})
export class PostRegisterFooterComponent  {
  showMyDataLogo:boolean= false;
  constructor() { }


}
